var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPress = function SvgPress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3254_10138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3254_10138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8001 13.6C2.4701 13.6 2.1876 13.4825 1.9526 13.2475C1.7176 13.0125 1.6001 12.73 1.6001 12.4V3.60002C1.6001 3.27002 1.7176 2.98752 1.9526 2.75252C2.1876 2.51752 2.4701 2.40002 2.8001 2.40002H13.2001C13.5301 2.40002 13.8126 2.51752 14.0476 2.75252C14.2826 2.98752 14.4001 3.27002 14.4001 3.60002V12.4C14.4001 12.73 14.2826 13.0125 14.0476 13.2475C13.8126 13.4825 13.5301 13.6 13.2001 13.6H2.8001ZM2.8001 12.4H13.2001V3.60002H2.8001V12.4ZM4.0001 10.8H12.0001V9.60002H4.0001V10.8ZM4.0001 8.40002H6.8001V4.80002H4.0001V8.40002ZM8.0001 8.40002H12.0001V7.20002H8.0001V8.40002ZM8.0001 6.00002H12.0001V4.80002H8.0001V6.00002Z",
    fill: "currentColor"
  }))));
};
export default SvgPress;